/* PauseClopes - Mega menu v2 - comportement */
(function () {
  var MOBILE = '(max-width: 1023px)';

  /* --- Arrivee en bas de page apres un clic ---------------------------------
     Chrome restaure parfois la position de defilement d'une visite precedente
     sur une nouvelle navigation. On remet en haut, mais UNIQUEMENT :
     - sur une vraie navigation (pas un retour arriere, ou la restauration est
       souhaitable),
     - s'il n'y a pas d'ancre dans l'URL,
     - et si l'internaute n'a pas deja fait defiler lui-meme.               */
  (function () {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (!entry || entry.type !== 'navigate') return;
      if (window.location.hash) return;
      var moved = false;
      function mark() { moved = true; }
      ['wheel', 'touchmove', 'keydown', 'mousedown'].forEach(function (ev) {
        window.addEventListener(ev, mark, { once: true, passive: true });
      });
      function toTop() { if (!moved && window.scrollY > 0) window.scrollTo(0, 0); }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', toTop);
      } else {
        toTop();
      }
      window.addEventListener('load', function () { toTop(); setTimeout(toTop, 250); });
    } catch (e) {}
  })();

  /* Filet de securite : si un script du theme plante, le voile de chargement
     #ajaxBusy reste affiche et masque toute la page. On le retire nous-memes. */
  function unveil() {
    var a = document.getElementById('ajaxBusy');
    if (a && a.style.display !== 'none' && a.offsetParent !== null) { a.style.display = 'none'; }
  }
  setTimeout(unveil, 2500);
  window.addEventListener('load', function () { setTimeout(unveil, 1200); });

  function init() {
    var nav = document.getElementById('pc-nav');
    if (!nav || nav.dataset.pcReady) return;
    nav.dataset.pcReady = '1';

    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-pc-item]'));
    var drawer = document.getElementById('pc-drawer');
    var burgers = Array.prototype.slice.call(document.querySelectorAll('.pc-burger'));
    var closeBtn = nav.querySelector('.pc-drawer__close');
    var overlay = nav.querySelector('.pc-overlay');
    var openTimer = null, closeTimer = null;

    function anchorTop() {
      var host = nav.closest('header') || nav.parentElement;
      if (!host) return;
      var b = Math.round(host.getBoundingClientRect().bottom);
      nav.style.setProperty('--pc-top', Math.max(0, b) + 'px');
    }

    /* Les barres d'annonce d'apps sont en position fixed avec un z-index tres
       eleve, hors de notre contexte d'empilement : on ne peut pas passer
       au-dessus. On decale donc le tiroir juste en dessous. */
    function anchorDrawer() {
      var max = 0, vh = window.innerHeight;
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i], s = window.getComputedStyle(el);
        if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden') continue;
        var z = parseInt(s.zIndex, 10);
        if (!(z > 9999)) continue;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < vh * 0.4 && r.top <= 1 && r.bottom > max) max = r.bottom;
      }
      nav.style.setProperty('--pc-drawer-top', Math.round(max) + 'px');
    }

    function setExpanded(li, state) {
      var b = li.querySelector('.pc-nav__link');
      if (b && b.tagName === 'BUTTON') b.setAttribute('aria-expanded', state ? 'true' : 'false');
    }

    function closeAll() {
      items.forEach(function (li) { li.classList.remove('is-open'); setExpanded(li, false); });
      if (!drawer || !drawer.classList.contains('is-open')) nav.classList.remove('is-active');
    }

    function openPanel(li) {
      anchorTop();
      items.forEach(function (o) { if (o !== li) { o.classList.remove('is-open'); setExpanded(o, false); } });
      li.classList.add('is-open');
      nav.classList.add('is-active');
      setExpanded(li, true);
    }

    items.forEach(function (li) {
      var btn = li.querySelector('.pc-nav__link');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(openTimer); clearTimeout(closeTimer);
        if (li.classList.contains('is-open')) { closeAll(); } else { openPanel(li); }
      });

      li.addEventListener('mouseenter', function () {
        if (window.matchMedia(MOBILE).matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openPanel(li); }, 80);
      });

      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAll, 280);
      });
    });

    function openDrawer() {
      if (!drawer) return;
      anchorDrawer();
      drawer.classList.add('is-open');
      nav.classList.add('is-active', 'is-drawer-open');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      nav.classList.remove('is-active', 'is-drawer-open');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
    }

    /* le tiroir peut rester ouvert pendant la navigation : on libere le scroll */
    window.addEventListener('pagehide', function () { document.body.style.overflow = ''; });

    burgers.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
      }, true);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', function () { closeAll(); closeDrawer(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { closeAll(); closeDrawer(); }
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll();
    });

    window.addEventListener('scroll', function () {
      if (nav.classList.contains('is-active')) anchorTop();
    }, { passive: true });
    window.addEventListener('resize', function () {
      anchorTop();
      if (drawer && drawer.classList.contains('is-open')) anchorDrawer();
    });

    Array.prototype.forEach.call(nav.querySelectorAll('.pc-acc__head'), function (head) {
      if (head.tagName !== 'BUTTON') return;
      head.addEventListener('click', function () {
        head.parentElement.classList.toggle('is-open');
      });
    });

    anchorTop();
    anchorDrawer();
    setTimeout(anchorTop, 400);
    setTimeout(function () { anchorTop(); anchorDrawer(); }, 1500);
    window.addEventListener('load', function () { anchorTop(); anchorDrawer(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
